export default __webpack_public_path__ + "static/made-okine-sans-bold-56c9308c605d22b7f82113418f057e2d.woff2";